module.exports = __webpack_public_path__ + "media/images/marker_icon-3d409690.svg";